import React from 'react';
import { IconCard } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { Link } from '@components/common/Link';
import { contractStore } from '@stores/contractStore';

import { IIconCardLinkFields } from '../types';

export const IconCardLink = observer(
  ({ data }: { data: IIconCardLinkFields }) => {
    if (
      data.hideFromResidents &&
      (contractStore.isUserNonContractParty || contractStore.isFetching)
    )
      return null;

    return (
      <IconCard
        wrapperComponent={Link}
        to={data.url ?? ''}
        heading={data.heading}
        body={data.body}
        className="w-full"
        iconClassName="text-brand-primary-main"
        icon={data.icon.icon ?? 'placeholder'}
        centered={data.centered}
      />
    );
  }
);
